import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=f021d0a4&scoped=true&"
import script from "./Layer.vue?vue&type=script&lang=js&"
export * from "./Layer.vue?vue&type=script&lang=js&"
import style0 from "./Layer.vue?vue&type=style&index=0&id=f021d0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f021d0a4",
  null
  
)

export default component.exports